import { MsalAuthProvider, LoginType } from 'react-aad-msal';

import jwt_decode from "jwt-decode";
import history from '../history';
//Redux
import { Store } from '../store/index';
import { UserState } from '../store/reducers/userReducer';
import { AxiosResponse } from 'axios';
import { useDispatch } from 'react-redux';
import axios, { AxiosAdapter } from 'axios';
import session from 'redux-persist/lib/storage/session';
import { CacheLocation, LogLevel } from 'msal';
// Msal Configurations

const getDynamicRedirectURL = () => {
    
    return window.location.origin || ''
}

const config = {
    auth: {
        authority: process.env.REACT_APP_AZURE_AUTHORITY || '',
        clientId: process.env.REACT_APP_AZURE_CLIENTID || '',
        redirectUri: window.location.origin || '', //process.env.REACT_APP_REDIRECTURI || '',
        postLogoutRedirectUri: window.location.origin
        
    }, cache: {
        cacheLocation: "localStorage" as CacheLocation,
        storeAuthStateInCookie: false
    }

};

// Authentication Parameters
const authenticationParameters = {
    scopes: ['User.Read'],
    // prompt: 'select_account' para  conversar sobre o login token https://docs.microsoft.com/en-us/azure/active-directory-b2c/identity-provider-google?pivots=b2c-user-flow
}
// const authenticationParametersAuthoirize = {
//     scopes: ['User.Read'],
//     prompt: 'consent'
// }

// Options
const options = {
    loginType: LoginType.Redirect,
    tokenRefreshUri: window.location.origin || '',
}

const authProviderMSal = new MsalAuthProvider(config, authenticationParameters, options)
// const authProviderMSalAuthoirize = new MsalAuthProvider(config, authenticationParametersAuthoirize, options)
var apiAxios = axios.create();
export const authProvider = {

    providerMSal: authProviderMSal,
    getAuthToken: function () {
        var Heyho_tokenAccess = localStorage && localStorage.getItem("Heyho_tokenAccess");
        return Heyho_tokenAccess != null;
    },

    LoginMSSO: async function () {
        authProviderMSal.login();
    },



    // AuthorizeOrganization: async function () {
    //     authProviderMSal.setAuthenticationParameters(authenticationParametersAuthoirize);

    //     authProviderMSal.login()
    // },

    GetAccessToken: async function () {
        await authProviderMSal.getAccessToken();

    },

    GetTokenHH: async function (accountInfo: any) {
        if (accountInfo.jwtAccessToken) {

            try {
                var debounceFlag = localStorage.getItem("RegisterUserAfterLogin");
                localStorage.setItem("Heyho_TokenMS", accountInfo.jwtAccessToken);
                if (!debounceFlag) {
                    localStorage.setItem("RegisterUserAfterLogin", "True");
                    try {
                        var responseToken: any = await apiAxios({
                            method: 'post',
                            url: `${process.env.REACT_APP_HH_APIENDPOINT}/AuthToken`,
                            headers: {
                                //'Content-Type': 'application/x-www-form-urlencoded',
                                'Authorization': `Bearer ${accountInfo.jwtAccessToken}`
                            },
                            withCredentials: false
                        });
                        
                        const Heyho_Token = responseToken.data.userAuthToken.access_token;
                        localStorage.setItem("Heyho_Token", Heyho_Token);
                        this.SaveUserSession(responseToken);
                    } 
                    catch (e: any) {
                        debugger;
                        try {
                            if (e && e.response && e.response.data) {
                                if (e.response.status == 400) {
                                    if (e.response.data.includes("[PROC]")) {
                                        localStorage && localStorage.clear();
                                        sessionStorage && sessionStorage.clear();
                                        alert(e.response.data + "  Entre em contato com o administrador com o usuario usado e um print da mensagem de erro no HeyHo.")
                                        history.push('/');
                                        window.location.reload();
                                        return false;
                                    }
                                }
                            }
                            if (e && e.response && e.response.data) {
                                if (e.response.status == 400) {
                                    if (e.response.data.includes("[MS]")) {
                                        localStorage && localStorage.clear();
                                        sessionStorage && sessionStorage.clear();
                                        history.push('/');
                                        window.location.reload();
                                        // this.providerMSal = new MsalAuthProvider(config, authenticationParametersAuthoirize, options)
                                        // this.providerMSal.login();
                                    }
                                }
                            }

                            if (e && e.message && e.message == "Network Error") {
                                alert("Estamos tendo problemas para conectar com o servidor HeyHo, entre em contato com o administrador HeyHo tambem e valido verificar se sua rede esta perfeitamente configurada.")
                                localStorage && localStorage.clear();
                                sessionStorage && sessionStorage.clear();
                                history.push('/');
                                window.location.reload();
                            }
                        } catch (ec) {
                            history.push('/');
                            return true;
                        }


                    }

                    return true;
                }
            }
            catch (e) {
                localStorage && localStorage.clear();
                window.location.reload();
            }
        }
        return false;
    },

    Renew: async function (CustomerId: number) {
        let token = localStorage.getItem("Heyho_AuthMS");

        try {
            // var response = await api({
            //     method: 'get',
            //     url: `${process.env.REACT_APP_HH_APIENDPOINT}/Account/RenewToken?idClienteSelected=${CustomerId}`,
            //     headers: { 'Authorization': `Bearer ${token}` },
            //     withCredentials: false,

            // });
            // this.SaveUserSession(response);
        } 
        catch (e) {
            localStorage && localStorage.clear();
            window.location.reload()
        }
    },

    LogOutMSSO: function () { 
        authProviderMSal.logout(); 
    },

    SaveUserSession: function (response: any) {
        // localStorage.setItem("Heyho_AuthLC", response.data.token);
        // var decoded = response.data  && response.data.token && jwt_decode(response.data.token) as UserState;

        // if (decoded && decoded.ClientGroupSelected && decoded.ClientGroupSelected > 0) {
        // try {
        // retrieveHistory(response);
        var decoded = response.data.userReturnHeyHo as UserState;
        decoded.Photo = response.data.userMS.photo;
        decoded.businessAreas = response.data.businessAreas;
        decoded.defaultCustomer = response.data.defaultCustomer;
        // decoded.VendorStatusList = response.data.vendorStatus;
        // decoded.Menus = response.data.menus
        // localStorage.setItem("ClientGroupSelected", decoded.ClientGroupSelected + "");
        // localStorage.setItem("ClientGroupList", response.data.clientGroupList + "");

        // decoded.ClientGroupList = response.data.clientGroupList.sort((a: any, b: any) => { return (a.defaultClientGroup || a.descricao < b.descricao) ? -1 : (!a.defaultClientGroup || a.descricao > b.descricao) ? 1 : 0 });
        // }
        // catch (e) { }

        // localStorage.setItem('HeyHo_LastMenuItem', '');
        // Store && Store.dispatch({ type: 'USER_UPDATE', payload: decoded });
        // Store && Store.dispatch({ type: 'AAD_AUTHENTICATED_STATE_CHANGED', payload: "Authenticated" });
        Store && Store.dispatch({ type: 'TOKENLC', payload: "Authenticated" });
        // Store && Store.dispatch({ type: 'MENU_SELECTED_UPDATE', payload: null });
        // Store && Store.dispatch({ type: 'MENU_SUBSELECTED_UPDATE', payload: null });
        // Store && Store.dispatch({ type: 'MENU_SUB_VISIBLE', payload: false });
        // localStorage.setItem('HeyHo_LastMenuItem', '');

        Store && Store.dispatch({ type: 'USER_UPDATE', payload: decoded });
        Store && Store.dispatch({ type: 'PREF_USER_ID', payload: decoded.id });

        // if (!(decoded.administrator && decoded.administrator === 1)) history.push('/');
        // }
    },

    // GenerateTokenEmailLogin: async function (email: string) {

    //     const url: string = `${process.env.REACT_APP_HH_APIENDPOINT}/Account/LoginWithEmailGenerateToken?email=${email}`;
    //     return await api({
    //         method: 'post',
    //         url: url
    //     });
    // },

}

export const configProvider = config;
